import script from "./MinimumRequestModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MinimumRequestModal.vue?vue&type=script&setup=true&lang=js"

import "./MinimumRequestModal.vue?vue&type=style&index=0&id=0a86493f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a86493f"]])

export default __exports__